/**
 * Bank details placeholders for consistent display across components
 */
export const BANK_DETAILS_PLACEHOLDERS = {
  SWIFT_CODE: "--------",
  IBAN: "---- ---- ---- ---- ---- ----",
  ROUTING_NUMBER: "-----",
  INSTITUTION_NUMBER: "---",
  ACCOUNT_NUMBER: "-------",
} as const
